<template>
  <v-list-tile class="list-tile-auto-height">
    <v-list-tile-content>
      <v-list-tile-title class="auto-height wrap">
        <v-layout align-center>
          <overlay-data-chip
            :disabled="disabled"
            @click="$emit('click')"
          />
          <span
            v-if="
              showNonDefaultPrice &&
                !!overlayOptions &&
                !!overlayData &&
                overlayData.price != defaultPrice
            "
            class="ml-2 unselectable blue--text font-weight-bold"
            :title="$t('price')"
          >
            {{ overlayData.price }} {{ currencySymbol }}
          </span>
        </v-layout>
      </v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
import OverlayDataChip from '@/components/OverlayDataChip';

export default {
  components: {
    OverlayDataChip,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Optional data to inspect/visualize, see props below.
     */
    overlayOptions: {
      type: Object,
      default: null,
    },
    /**
     * Optional data to inspect/visualize, see props below.
     */
    overlayData: {
      type: Object,
      default: null,
    },
    /**
     * If we have the data, show the price value unless it's the default.
     *
     * We opted for price here to show by default, as it's usually the
     * most important fields across all our editable clips. We rely on
     * the field being named 'price' here.
     */
    showNonDefaultPrice: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    defaultPrice() {
      if (
        !this.overlayOptions ||
        !this.overlayOptions.dynamic_fields ||
        !this.overlayOptions.dynamic_fields.data ||
        !this.overlayOptions.dynamic_fields.data.price ||
        !this.overlayOptions.dynamic_fields.data.price.default_value
      ) {
        return null;
      }
      return this.overlayOptions.dynamic_fields.data.price.default_value;
    },
    currencySymbol() {
      if (
        !this.overlayOptions ||
        !this.overlayOptions.dynamic_fields ||
        !this.overlayOptions.dynamic_fields.data ||
        !this.overlayOptions.dynamic_fields.data.price ||
        !this.overlayOptions.dynamic_fields.data.price.currency_symbol
      ) {
        return '€';
      }
      return this.overlayOptions.dynamic_fields.data.price.currency_symbol;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OverlayDataListTile.vue